import React from 'react';
import {
  FaHtml5,
  FaReact,
  FaAngular,
  FaNodeJs,
  FaGitAlt,
  FaFigma,
} from "react-icons/fa";
import { IoLogoCss3 } from "react-icons/io";
import { DiMongodb } from "react-icons/di";
import {
  SiJavascript,
  SiPostgresql,
  SiPostman,
  SiTailwindcss,
  SiInsomnia,
} from "react-icons/si";
import { BsBootstrapFill } from "react-icons/bs";


const skillBg = {
  backgroundColor: 'var(--about-bg)'
}
const Skills = (props) => {

  const [darkToggle, setDarkToggle] = React.useState(false)

  return (
    <section className={`w-full flex flex-col gap-4 px-4 py-16 glass`} id={props.id}>

      <div className='card shadow-2xl text-center flex justify-center w-full rounded glass'>
        <div className='rounded' style={skillBg}>  
        <h2 className="p-5 text-4xl font-bold text-white">
          What I Am Great At.
        </h2>
        <p className="font-bold text-white">
          Here are the skills i have aquired while working on different
          projects.
        </p>
        </div>
      </div>


      <div className="flex flex-col w-full lg:flex-row p-4 text-3xl text-white gap-4">
        <div className="grid flex-grow bg-blue-300 h-64 card rounded place-items-center gap-28">
          <ul>
            <li className="flex flex-row justify-start gap-6">
              <FaHtml5 style={{ fill: "#E65100" }} /> <span>HTML5</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <BsBootstrapFill style={{ fill: "#673AB7" }} />{" "}
              <span>Bootstrap</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <IoLogoCss3 style={{ fill: "#0277BD" }} /> <span>CSS3</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <SiTailwindcss style={{ fill: "#00ACC1" }} />{" "}
              <span>Tailwind CSS</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <SiJavascript style={{ fill: "#FFD600" }} />{" "}
              <span>JavaScript ES6+</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <FaReact style={{ fill: "#80DEEA" }} /> <span>React.js</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <SiInsomnia style={{ fill: "#6301d5" }} /> <span>Insomnia</span>
            </li>
          </ul>
        </div>
        <div className="divider lg:divider-horizontal"></div>
        <div className="grid flex-grow bg-blue-300 h-64 card rounded place-items-center gap-28">
          <ul>
            <li className="flex flex-row justify-start gap-6">
              <FaAngular style={{ fill: "#DD2C00" }} /> <span>Angular</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <FaNodeJs style={{ fill: "#388E3C" }} /> <span>Node.js</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <SiPostgresql style={{ fill: "#0277BD" }} />{" "}
              <span>Postgresql</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <DiMongodb style={{ fill: "#4aad3f" }} /> <span>MongoDB</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <FaGitAlt style={{ fill: "#F4511E" }} /> <span>Git</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <FaFigma style={{ fill: "#E64A19" }} /> <span>Figma</span>
            </li>
            <li className="flex flex-row justify-start gap-6">
              <SiPostman style={{ fill: "#f76836" }} /> <span>Postman</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Skills;